import { render, staticRenderFns } from "./ProductTagCategoryEdit.vue?vue&type=template&id=92e7ed92&scoped=true&"
import script from "./ProductTagCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./ProductTagCategoryEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductTagCategoryEdit.vue?vue&type=style&index=0&id=92e7ed92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e7ed92",
  null
  
)

export default component.exports